var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("contract-filters-controller", {
    attrs: {
      requestfilter: _vm.elpc.requestfilter,
      resetfilters: _vm.elpc.routereset,
      types: _vm.elpc.dictionaries.types,
    },
    on: { "filters:update": _vm.elpc.processRequestUpdate },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (cfc) {
          return [
            _c("div", { staticClass: "atmo-entity-filters" }, [
              _c(
                "form",
                {
                  staticClass: "atmo-form",
                  attrs: { id: "form-purchase-filters" },
                },
                [
                  _c("fieldset", { staticClass: "atmo-group atmo-mobile" }, [
                    _c(
                      "div",
                      { staticClass: "atmo-form__field" },
                      [
                        _c(
                          "multiselect",
                          {
                            attrs: {
                              id: "purchase-deliverables-groups",
                              options: _vm.elpc.dictionaries.deliverablesgroups,
                              multiple: true,
                              "allow-empty": true,
                              "close-on-select": true,
                              "clear-on-select": false,
                              "preserve-search": false,
                              "show-labels": false,
                              placeholder: "Выберите предметы закупки",
                              label: "title",
                              "track-by": "id",
                            },
                            on: {
                              select: function ($event) {
                                return cfc.processDictionaryFilterUpdate(
                                  $event,
                                  "add",
                                  "purchaseCategories"
                                )
                              },
                              remove: function ($event) {
                                return cfc.processDictionaryFilterUpdate(
                                  $event,
                                  "remove",
                                  "purchaseCategories"
                                )
                              },
                            },
                            model: {
                              value: cfc.deliverablesgroups,
                              callback: function ($$v) {
                                _vm.$set(cfc, "deliverablesgroups", $$v)
                              },
                              expression: "cfc.deliverablesgroups",
                            },
                          },
                          [
                            _c(
                              "span",
                              {
                                attrs: { slot: "noOptions" },
                                slot: "noOptions",
                              },
                              [_vm._v("Нет данных.")]
                            ),
                            _c(
                              "span",
                              { attrs: { slot: "noResult" }, slot: "noResult" },
                              [
                                _vm._v(
                                  "Записей, соответствующих вашему запросу, не найдено."
                                ),
                              ]
                            ),
                          ]
                        ),
                        _c(
                          "label",
                          { attrs: { for: "purchase-deliverables-groups" } },
                          [_vm._v("Предметы закупки")]
                        ),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "atmo-form__field" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: cfc.filters.conditionname,
                            expression: "cfc.filters.conditionname",
                          },
                        ],
                        attrs: {
                          type: "text",
                          id: "purchase-conditionname",
                          placeholder: "Укажите наименование ТРУ",
                          autocomplete: "off",
                        },
                        domProps: { value: cfc.filters.conditionname },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              cfc.filters,
                              "conditionname",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _c(
                        "label",
                        { attrs: { for: "purchase-conditionname" } },
                        [_vm._v("Наименование ТРУ")]
                      ),
                    ]),
                  ]),
                  _c(
                    "fieldset",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: cfc.isFiltersVisible,
                          expression: "cfc.isFiltersVisible",
                        },
                      ],
                      staticClass: "atmo-group atmo-tablet",
                    },
                    [
                      _c("div", { staticClass: "atmo-form__field" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: cfc.filters.regNumber,
                              expression: "cfc.filters.regNumber",
                            },
                          ],
                          attrs: {
                            type: "text",
                            id: "purchase-regNumber",
                            placeholder: "Укажите номер закупки",
                            autocomplete: "off",
                          },
                          domProps: { value: cfc.filters.regNumber },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                cfc.filters,
                                "regNumber",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _c("label", { attrs: { for: "purchase-regNumber" } }, [
                          _vm._v("Регистрационный номер закупки"),
                        ]),
                      ]),
                      _c("div", { staticClass: "atmo-form__field" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: cfc.filters.customer,
                              expression: "cfc.filters.customer",
                            },
                          ],
                          attrs: {
                            type: "text",
                            id: "purchase-customer",
                            placeholder: "Укажите наименование/ИНН заказчика",
                            autocomplete: "off",
                          },
                          domProps: { value: cfc.filters.customer },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                cfc.filters,
                                "customer",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _c("label", { attrs: { for: "purchase-customer" } }, [
                          _vm._v("Заказчик"),
                        ]),
                      ]),
                      _c("div", { staticClass: "atmo-form__field" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: cfc.filters.provider,
                              expression: "cfc.filters.provider",
                            },
                          ],
                          attrs: {
                            type: "text",
                            id: "purchase-provider",
                            placeholder: "Укажите наименование/ИНН поставщика",
                            autocomplete: "off",
                          },
                          domProps: { value: cfc.filters.provider },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                cfc.filters,
                                "provider",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _c("label", { attrs: { for: "purchase-provider" } }, [
                          _vm._v("Поставщик"),
                        ]),
                      ]),
                      _c(
                        "div",
                        { staticClass: "atmo-form__field" },
                        [
                          _c("dropdown-select", {
                            attrs: {
                              list: cfc.types,
                              initialid: cfc.contracttype.currentid,
                              currentid: cfc.contracttype.currentid,
                            },
                            on: {
                              "dropdown:select:selected": cfc.manageSelection,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ds) {
                                    return [
                                      _c("on-off", {
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (onoff) {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "atmo-dropdown-select",
                                                    },
                                                    [
                                                      _c(
                                                        "button",
                                                        {
                                                          attrs: {
                                                            type: "button",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                              return onoff.toggle.apply(
                                                                null,
                                                                arguments
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          !ds.hasSelected
                                                            ? _c("span", [
                                                                _vm._v("Любой"),
                                                              ])
                                                            : _vm._e(),
                                                          ds.hasSelected
                                                            ? _c("span", {
                                                                domProps: {
                                                                  innerHTML:
                                                                    _vm._s(
                                                                      ds.text
                                                                    ),
                                                                },
                                                              })
                                                            : _vm._e(),
                                                        ]
                                                      ),
                                                      _c(
                                                        "ul",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "show",
                                                              rawName: "v-show",
                                                              value: onoff.ison,
                                                              expression:
                                                                "onoff.ison",
                                                            },
                                                          ],
                                                          staticClass:
                                                            "atmo-dropdown",
                                                        },
                                                        [
                                                          _c(
                                                            "li",
                                                            {
                                                              on: {
                                                                click: ds.clear,
                                                              },
                                                            },
                                                            [_vm._v("Любой")]
                                                          ),
                                                          _vm._l(
                                                            ds.list,
                                                            function (item) {
                                                              return _c(
                                                                "li",
                                                                {
                                                                  key: item.id,
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return ds.select(
                                                                          item.id
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _c("span", {
                                                                    domProps: {
                                                                      innerHTML:
                                                                        _vm._s(
                                                                          item.title
                                                                        ),
                                                                    },
                                                                  }),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                        ],
                                                        2
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                          _c(
                            "label",
                            { attrs: { for: "purchase-contracttype" } },
                            [_vm._v("Тип контракта")]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "fieldset",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: cfc.isFiltersVisible,
                          expression: "cfc.isFiltersVisible",
                        },
                      ],
                      staticClass: "atmo-group atmo-tablet",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "atmo-form__field" },
                        [
                          _c("currency-input", {
                            attrs: {
                              currency: "RUB",
                              locale: "ru",
                              "allow-negative": false,
                              precision: 0,
                              type: "text",
                              id: "purchase-fromStartPrice",
                              placeholder: "НЦК от...",
                              autocomplete: "off",
                            },
                            model: {
                              value: cfc.filters.fromStartPrice,
                              callback: function ($$v) {
                                _vm.$set(cfc.filters, "fromStartPrice", $$v)
                              },
                              expression: "cfc.filters.fromStartPrice",
                            },
                          }),
                          _c(
                            "label",
                            { attrs: { for: "purchase-fromStartPrice" } },
                            [_vm._v("НЦК от...")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "atmo-form__field" },
                        [
                          _c("currency-input", {
                            attrs: {
                              currency: "RUB",
                              locale: "ru",
                              "allow-negative": false,
                              precision: 0,
                              type: "text",
                              id: "purchase-toStartPrice",
                              placeholder: "НЦК до...",
                              autocomplete: "off",
                            },
                            model: {
                              value: cfc.filters.toStartPrice,
                              callback: function ($$v) {
                                _vm.$set(cfc.filters, "toStartPrice", $$v)
                              },
                              expression: "cfc.filters.toStartPrice",
                            },
                          }),
                          _c(
                            "label",
                            { attrs: { for: "purchase-toStartPrice" } },
                            [_vm._v("НЦК до...")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "atmo-form__field" },
                        [
                          _c("date-picker", {
                            attrs: {
                              id: "purchase-fromPurchaseStart",
                              label: "Укажите дату размещения с",
                              "button-now-translation": "Сегодня",
                              format: "YYYY-MM-DD",
                              formatted: "DD.MM.YYYY",
                              "max-date": cfc.filters.toPurchaseStart,
                              "no-label": !!cfc.filters.fromPurchaseStart,
                              "auto-close": true,
                              "only-date": true,
                            },
                            model: {
                              value: cfc.filters.fromPurchaseStart,
                              callback: function ($$v) {
                                _vm.$set(cfc.filters, "fromPurchaseStart", $$v)
                              },
                              expression: "cfc.filters.fromPurchaseStart",
                            },
                          }),
                          _c(
                            "label",
                            {
                              attrs: {
                                for: "purchase-fromPurchaseStart-input",
                              },
                            },
                            [_vm._v("Дата размещения с...")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "atmo-form__field" },
                        [
                          _c("date-picker", {
                            attrs: {
                              id: "purchase-toPurchaseStart",
                              label: "Укажите дату размещения по",
                              "button-now-translation": "Сегодня",
                              format: "YYYY-MM-DD",
                              formatted: "DD.MM.YYYY",
                              "min-date": cfc.filters.fromPurchaseStart,
                              "no-label": !!cfc.filters.toPurchaseStart,
                              "auto-close": true,
                              "only-date": true,
                            },
                            model: {
                              value: cfc.filters.toPurchaseStart,
                              callback: function ($$v) {
                                _vm.$set(cfc.filters, "toPurchaseStart", $$v)
                              },
                              expression: "cfc.filters.toPurchaseStart",
                            },
                          }),
                          _c(
                            "label",
                            {
                              attrs: { for: "purchase-toPurchaseStart-input" },
                            },
                            [_vm._v("Дата размещения по...")]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "fieldset",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: cfc.isFiltersVisible,
                          expression: "cfc.isFiltersVisible",
                        },
                      ],
                      staticClass: "atmo-group atmo-tablet",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "atmo-form__field" },
                        [
                          _c(
                            "multiselect",
                            {
                              attrs: {
                                id: "purchase-municipalities",
                                options: _vm.elpc.dictionaries.municipalities,
                                multiple: true,
                                "allow-empty": true,
                                "close-on-select": true,
                                "clear-on-select": false,
                                "preserve-search": false,
                                "show-labels": false,
                                placeholder: "Выберите муниципалитет",
                                label: "title",
                                "track-by": "id",
                              },
                              on: {
                                select: function ($event) {
                                  return cfc.processDictionaryFilterUpdate(
                                    $event,
                                    "add",
                                    "municipalities"
                                  )
                                },
                                remove: function ($event) {
                                  return cfc.processDictionaryFilterUpdate(
                                    $event,
                                    "remove",
                                    "municipalities"
                                  )
                                },
                              },
                              model: {
                                value: cfc.municipalities,
                                callback: function ($$v) {
                                  _vm.$set(cfc, "municipalities", $$v)
                                },
                                expression: "cfc.municipalities",
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  attrs: { slot: "noOptions" },
                                  slot: "noOptions",
                                },
                                [_vm._v("Нет данных.")]
                              ),
                              _c(
                                "span",
                                {
                                  attrs: { slot: "noResult" },
                                  slot: "noResult",
                                },
                                [
                                  _vm._v(
                                    "Записей, соответствующих вашему запросу, не найдено."
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "label",
                            { attrs: { for: "purchase-municipalities" } },
                            [_vm._v("Муниципалитеты")]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              ),
              _c(
                "ul",
                { staticClass: "atmo-buttons atmo-special atmo-mobile" },
                [
                  _c("li", [
                    _c(
                      "button",
                      {
                        staticClass: "atmo-button-inverse",
                        attrs: { disabled: !cfc.hasFiltersChanged },
                        on: { click: cfc.search },
                      },
                      [_vm._v("Найти")]
                    ),
                  ]),
                  _c("li", [
                    _c(
                      "button",
                      {
                        staticClass: "atmo-button-border-only",
                        on: { click: cfc.toggleFilters },
                      },
                      [
                        !cfc.isFiltersVisible
                          ? _c("span", [_vm._v("Все фильтры")])
                          : _vm._e(),
                        cfc.isFiltersVisible
                          ? _c("span", [_vm._v("Меньше фильтров")])
                          : _vm._e(),
                      ]
                    ),
                  ]),
                  _c("li", [
                    _c(
                      "button",
                      {
                        staticClass: "atmo-button-border-only",
                        attrs: { disabled: cfc.isFiltersEmpty },
                        on: { click: cfc.reset },
                      },
                      [_vm._v("Сбросить")]
                    ),
                  ]),
                ]
              ),
            ]),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }